import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Trophy, Medal, Star, Flame } from 'lucide-react';

export default function AlunoMedalhasPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/aluno/dashboard')
      .then(res => setData(res.data))
      .finally(() => setLoading(false));
  }, []);

  const medalhas = data?.gamificacao?.medalhas || [];
  const totalXP = medalhas.reduce((total, m) => total + Number(m.xp || 0), 0);

  if (loading) {
    return <div className="text-zinc-500">Carregando medalhas...</div>;
  }

  return (
    <div className="space-y-6 animate-fadeIn">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-3xl font-black font-['Barlow_Condensed'] tracking-tight uppercase text-white">
            Minhas Medalhas
          </h1>
          <p className="text-sm text-zinc-500">
            Suas conquistas, troféus especiais e recompensas dentro do clube.
          </p>
        </div>

        <Badge className="bg-yellow-500/10 text-yellow-400 border-yellow-500/20">
          <Trophy className="w-4 h-4 mr-1" />
          {medalhas.length} medalha(s)
        </Badge>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card className="bg-[#141414] border-[#27272A]">
          <CardContent className="p-5">
            <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-bold">Total</p>
            <h2 className="text-3xl font-black font-['Barlow_Condensed'] text-white mt-1">
              {medalhas.length}
            </h2>
            <p className="text-sm text-zinc-500">medalhas conquistadas</p>
          </CardContent>
        </Card>

        <Card className="bg-[#141414] border-[#27272A]">
          <CardContent className="p-5">
            <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-bold">XP Especial</p>
            <h2 className="text-3xl font-black font-['Barlow_Condensed'] text-yellow-400 mt-1">
              {totalXP}
            </h2>
            <p className="text-sm text-zinc-500">XP vindo de medalhas</p>
          </CardContent>
        </Card>

        <Card className="bg-[#141414] border-[#27272A]">
          <CardContent className="p-5">
            <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-bold">Status</p>
            <h2 className="text-3xl font-black font-['Barlow_Condensed'] text-white mt-1">
              Ativo
            </h2>
            <p className="text-sm text-zinc-500">continue conquistando</p>
          </CardContent>
        </Card>
      </div>

      <Card className="bg-gradient-to-br from-[#141414] to-[#0A0A0A] border-[#27272A]">
        <CardContent className="p-5">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-12 h-12 rounded-2xl bg-yellow-500/10 flex items-center justify-center">
              <Medal className="w-6 h-6 text-yellow-400" />
            </div>

            <div>
              <h2 className="text-xl font-black font-['Barlow_Condensed'] uppercase text-white">
                Galeria de Conquistas
              </h2>
              <p className="text-sm text-zinc-500">
                Medalhas automáticas e troféus especiais concedidos pela equipe.
              </p>
            </div>
          </div>

          {medalhas.length === 0 ? (
            <div className="bg-[#0A0A0A] border border-[#27272A] rounded-2xl p-6 text-center">
              <Trophy className="w-10 h-10 text-zinc-600 mx-auto mb-3" />
              <p className="text-white font-bold">Nenhuma medalha ainda</p>
              <p className="text-sm text-zinc-500 mt-1">
                Participe dos treinos, mantenha sua mensalidade em dia e evolua no ranking.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              {medalhas.map((m, i) => (
                <div
                  key={m.medalha_id || i}
                  className="bg-[#0A0A0A] border border-[#27272A] rounded-2xl p-4 hover:border-yellow-500/30 transition-all"
                >
                  <div className="flex items-start justify-between gap-3">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 rounded-2xl bg-yellow-500/10 flex items-center justify-center text-2xl">
                        {m.icone || '🏅'}
                      </div>

                      <div>
                        <p className="font-bold text-white">{m.nome}</p>
                        <p className="text-xs text-zinc-500 mt-0.5">
                          {m.descricao || 'Conquista desbloqueada.'}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center justify-between mt-4">
                    <Badge className="bg-yellow-500/10 text-yellow-400 border-yellow-500/20">
                      <Star className="w-3.5 h-3.5 mr-1" />
                      Medalha
                    </Badge>

                    <Badge className="bg-orange-500/10 text-orange-400 border-orange-500/20">
                      <Flame className="w-3.5 h-3.5 mr-1" />
                      {Number(m.xp || 0)} XP
                    </Badge>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
